import CompanyNavigationIcon from 'assets/icons/company.svg?react';
import { CommonTranslationKeys } from 'intl/keys';
import ContractNavigationIcon from 'assets/icons/contract.svg?react';
import AnalyticsNavigationIcon from 'assets/icons/navigation_analytics.svg?react';
import BrowseInspectionNavigationIcon from 'assets/icons/navigation_browseInspections.svg?react';
import InspectionNavigationIcon from 'assets/icons/navigation_inspections.svg?react';
import IssueNavigationIcon from 'assets/icons/navigation_issues.svg?react';
import ProjectPreviewNavigationIcon from 'assets/icons/navigation_project_preview.svg?react';
import StartInspectionNavigationIcon from 'assets/icons/navigation_startInspection.svg?react';
import UserNavigationIcon from 'assets/icons/user.svg?react';
import { NavigationDestination } from 'helpers/navigation';
import { APP_PATHS } from 'setup/navigation/paths';
import { DocumentationIcon } from './icons';
import { NavigationItemDefinition } from './types';

export const NAVIGATION_ITEMS: NavigationItemDefinition[] = [
  {
    key: NavigationDestination.issues,
    textId: CommonTranslationKeys.navigationDrawerItemIssues,
    icon: IssueNavigationIcon,
    path: APP_PATHS.issue.root,
  },
  {
    key: NavigationDestination.inspections,
    textId: CommonTranslationKeys.navigationDrawerItemInspections,
    icon: InspectionNavigationIcon,
    access: 'inspections',
  },
  {
    key: NavigationDestination.browseInspectionTemplates,
    textId: CommonTranslationKeys.temporaryKeyNavigationTemplates,
    icon: StartInspectionNavigationIcon,
    subItem: true,
    path: (ctx) => APP_PATHS.inspectionTemplate.root(ctx.projectId),
    access: 'inspections',
    state: (ctx) =>
      ctx.templateIdFromInspection
        ? { templateId: ctx.templateIdFromInspection }
        : undefined,
  },
  {
    key: NavigationDestination.browseInspections,
    textId: 'navigation_drawer_item_browseInspections',
    icon: BrowseInspectionNavigationIcon,
    path: APP_PATHS.inspection.root,
    subItem: true,
    access: 'inspections',
  },
  {
    key: NavigationDestination.documentations,
    textId: CommonTranslationKeys.documentation,
    icon: DocumentationIcon,
    path: (ctx) => APP_PATHS.documentation.root(ctx.projectId),
  },
  {
    key: NavigationDestination.analytics,
    textId: CommonTranslationKeys.navigationDrawerItemAnalytics,
    icon: AnalyticsNavigationIcon,
    path: APP_PATHS.analytics.root,
  },
  {
    key: NavigationDestination.companies,
    textId: CommonTranslationKeys.navigationDrawerItemCompany,
    icon: CompanyNavigationIcon,
    path: APP_PATHS.company.root,
  },
  {
    key: NavigationDestination.contracts,
    textId: CommonTranslationKeys.navigationDrawerItemContract,
    icon: ContractNavigationIcon,
    path: APP_PATHS.contract.root,
  },
  {
    key: NavigationDestination.users,
    textId: CommonTranslationKeys.navigationDrawerItemUsers,
    icon: UserNavigationIcon,
    path: APP_PATHS.user.root,
    access: 'users',
  },
  {
    key: NavigationDestination.projectSettings,
    textId: CommonTranslationKeys.project,
    icon: ProjectPreviewNavigationIcon,
    path: APP_PATHS.project.settings.root,
    access: 'projectSettings',
  },
];
